import { defineStore } from "pinia";
import { ref } from "vue";

// const debug: boolean = process.env.NODE_ENV !== "production";

export interface State {
	orgnummer: string,
	kod: string,
	verifierad: boolean,
	felmeddelande: string,
	foretagsnamn: string,
	orgnummerKomplett: string, // Svar från backend (innehåller eventuellt sekel)
	arForetag: boolean,
	staKvar: boolean,
	epost: string | null,
	kvittensnummer: string,
	ankomsttid: number, // epochinseconds
	vantarPaResponse: boolean,
};

export const useStore = defineStore("store", () => {
	const state = ref<State>({
		orgnummer: "",
		kod: "",
		verifierad: false,
		felmeddelande: "",
		foretagsnamn: "",
		orgnummerKomplett: "",
		arForetag: true,
		staKvar: false,
		epost: null,
		kvittensnummer: "",
		ankomsttid: 0,
		vantarPaResponse: false,
	});

	const aterstall = () => {
		state.value.felmeddelande = "";
		state.value.verifierad = false;
	};

	return {
		state,
		aterstall,
	};
});